import { Injectable, EventEmitter } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { QuizInstancesService } from '@app/api/api-services/quiz-instances.service';
import { CustomToastersService } from 'src/app/shared/services/custom-toasters.service';
import { RouteHelperService } from 'src/app/shared/services/route-helper.service';
import { QuizResponse } from 'src/app/shared/enums/quiz-response.enum';
import { StartQuizModalComponent } from '../modals/start-quiz-modal/start-quiz-modal.component';
import { InitializedQuizApiModel } from '@app/api/api-models';

@Injectable()
export class StartQuizService {
  public onCreating = new EventEmitter<boolean>();

  constructor(
    private readonly quizInstancesService: QuizInstancesService,
    private readonly customToasters: CustomToastersService,
    private readonly bsModalService: BsModalService,
    private readonly routeHelper: RouteHelperService
  ) {}

  public start(id: number): void {
    this.onCreating.emit(true);

    this.quizInstancesService.getInitialized(id).subscribe(
      (response) => {
        this.handleStart(response);

        if (response.IsTrainingCourses) {
          this.routeHelper.trainingCoursesDashboard();
        } else {
          this.routeHelper.dashboard();
        }
      },
      () => {
        this.customToasters.failLoad();
        this.releaseCreation();
      }
    );
  }

  public handleStart(quiz: InitializedQuizApiModel): void {
    const initialState = {
      quiz: quiz,
      confirm: this.processStep.bind(this, quiz),
      reject: this.releaseCreation.bind(this)
    };

    this.bsModalService.show(StartQuizModalComponent, {
      initialState,
      backdrop: 'static'
    });
  }

  private processStep(quiz: InitializedQuizApiModel): void {
    this.customToasters.waitSave();

    const model = {
      QuizId: quiz.Id,
      WorkflowStepId: quiz.CurrentStepId,
      Response: QuizResponse.Start,
      Comment: '',
      UsersToNotify: []
    };

    this.quizInstancesService.processStep(model).subscribe(
      () => {
        this.customToasters.completeSave();
        this.routeHelper.quizInstance(quiz.Id);
      },
      () => {
        this.customToasters.failSave();
        this.releaseCreation();
      }
    );
  }

  private releaseCreation(): void {
    this.onCreating.emit(false);
  }
}
